<template>
    <div class="calendar-day__item">
        <div  class="row row__header" :class="{'row__header_with-scroll': doesListItemsHaveScroll}">
            <div class="row__name"> {{dateFormat(this.$route.query.first_day, 'Do MMMM')}} </div>
            <div class="row__times">
                <div  class="time">8:00</div>
                <div  class="time">9:00</div>
                <div  class="time">10:00</div>
                <div  class="time">11:00</div>
                <div  class="time">12:00</div>
                <div  class="time">13:00</div>
                <div  class="time">14:00</div>
                <div  class="time">15:00</div>
                <div  class="time">16:00</div>
                <div  class="time">17:00</div>
                <div  class="time">18:00</div>
                <div  class="time">19:00</div>
            </div>
            <div class="row__stats statistic row__stats statistic_head">
                <div  class="statistic-item">
                    <p  class="statistic-item_text"> booked </p>
                </div>
                <div  class="statistic-item">
                    <p  class="statistic-item_text"> workload </p>
                </div>
                <div  class="statistic-item">
                    <p  class="statistic-item_text">travel time</p>
                </div>
                <div  class="statistic-item">
<!--                    <p  class="statistic-item_text">inactive</p>-->
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
import dateMixin from '@/mixins/dateMixin';
import {mapGetters} from "vuex";

export default {
    mixins: [dateMixin],
    computed: {
        ...mapGetters({
            doesListItemsHaveScroll: 'calendar/doesListItemsHaveScroll'
        }),
    }
}
</script>
